import api, { getUserFromCtx } from 'shared/api'
import slugfy from 'slug'

const defaultProps = {}
const propTypes = {}

export async function getServerSideProps(context) {
  const user = getUserFromCtx(context)
  const { query } = context
  const { groupId } = query

  try {
    const { data } = await api.get(`/public/groups/${groupId}`, {
      headers: {
        Authorization: `Bearer ${user?.accessToken}`,
      },
    })

    const slug = slugfy(data?.name)

    return {
      redirect: {
        destination: `/groups/${groupId}/${slug}`,
        permanent: false,
      },
    }
  } catch (e) {
    return {
      props: {
        errorCode: 404,
      },
    }
  }
}

export const Page = () => <div />

Page.defaultProps = defaultProps
Page.propTypes = propTypes

export default Page
